import { render, staticRenderFns } from "./EditFormTemplate.vue?vue&type=template&id=ca37f0c2&scoped=true&"
import script from "./EditFormTemplate.vue?vue&type=script&lang=js&"
export * from "./EditFormTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EditFormTemplate.vue?vue&type=style&index=0&id=ca37f0c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca37f0c2",
  null
  
)

export default component.exports